firstProductData = [
  {
    "boy": "140 - 149",
    "kilo": "40 - 50",
    "vke": "22,22",
    "product": "Yumuşak"
  },
  {
    "boy": "150 - 159",
    "kilo": "40 - 50",
    "vke": "19,53",
    "product": "Yumuşak"
  },
  {
    "boy": "160 - 169",
    "kilo": "40 - 50",
    "vke": "17,3",
    "product": "Yumuşak"
  },
  {
    "boy": "170 - 179",
    "kilo": "40 - 50",
    "vke": "15,43",
    "product": "Yumuşak"
  },
  {
    "boy": "180 - 189",
    "kilo": "40 - 50",
    "vke": "13,85",
    "product": "Yumuşak"
  },
  {
    "boy": "190 - 199",
    "kilo": "40 - 50",
    "vke": "12,5",
    "product": "Yumuşak"
  },
  {
    "boy": "200+",
    "kilo": "40 - 50",
    "vke": "11,34",
    "product": "Yumuşak"
  },
  {
    "boy": "140 - 149",
    "kilo": "51 - 55",
    "vke": "24,44",
    "product": "Orta"
  },
  {
    "boy": "150 - 159",
    "kilo": "51 - 55",
    "vke": "21,48",
    "product": "Yumuşak"
  },
  {
    "boy": "160 - 169",
    "kilo": "51 - 55",
    "vke": "19,03",
    "product": "Yumuşak"
  },
  {
    "boy": "170 - 179",
    "kilo": "51 - 55",
    "vke": "16,98",
    "product": "Yumuşak"
  },
  {
    "boy": "180 - 189",
    "kilo": "51 - 55",
    "vke": "15,24",
    "product": "Yumuşak"
  },
  {
    "boy": "190 - 199",
    "kilo": "51 - 55",
    "vke": "13,75",
    "product": "Yumuşak"
  },
  {
    "boy": "200+",
    "kilo": "51 - 55",
    "vke": "12,47",
    "product": "Yumuşak"
  },
  {
    "boy": "140 - 149",
    "kilo": "56 - 60",
    "vke": "26,67",
    "product": "Orta"
  },
  {
    "boy": "150 - 159",
    "kilo": "56 - 60",
    "vke": "23,44",
    "product": "Yumuşak"
  },
  {
    "boy": "160 - 169",
    "kilo": "56 - 60",
    "vke": "20,76",
    "product": "Yumuşak"
  },
  {
    "boy": "170 - 179",
    "kilo": "56 - 60",
    "vke": "18,52",
    "product": "Yumuşak"
  },
  {
    "boy": "180 - 189",
    "kilo": "56 - 60",
    "vke": "16,62",
    "product": "Yumuşak"
  },
  {
    "boy": "190 - 199",
    "kilo": "56 - 60",
    "vke": "15",
    "product": "Yumuşak"
  },
  {
    "boy": "200+",
    "kilo": "56 - 60",
    "vke": "13,61",
    "product": "Yumuşak"
  },
  {
    "boy": "140 - 149",
    "kilo": "61 - 65",
    "vke": "28,89",
    "product": "Orta"
  },
  {
    "boy": "150 - 159",
    "kilo": "61 - 65",
    "vke": "25,39",
    "product": "Orta"
  },
  {
    "boy": "160 - 169",
    "kilo": "61 - 65",
    "vke": "22,49",
    "product": "Orta"
  },
  {
    "boy": "170 - 179",
    "kilo": "61 - 65",
    "vke": "20,06",
    "product": "Orta"
  },
  {
    "boy": "180 - 189",
    "kilo": "61 - 65",
    "vke": "18,01",
    "product": "Orta"
  },
  {
    "boy": "190 - 199",
    "kilo": "61 - 65",
    "vke": "16,25",
    "product": "Yumuşak"
  },
  {
    "boy": "200+",
    "kilo": "61 - 65",
    "vke": "14,74",
    "product": "Yumuşak"
  },
  {
    "boy": "140 - 149",
    "kilo": "66 - 70",
    "vke": "31,11",
    "product": "Orta"
  },
  {
    "boy": "150 - 159",
    "kilo": "66 - 70",
    "vke": "27,34",
    "product": "Orta"
  },
  {
    "boy": "160 - 169",
    "kilo": "66 - 70",
    "vke": "24,22",
    "product": "Orta"
  },
  {
    "boy": "170 - 179",
    "kilo": "66 - 70",
    "vke": "21,6",
    "product": "Orta"
  },
  {
    "boy": "180 - 189",
    "kilo": "66 - 70",
    "vke": "19,39",
    "product": "Orta"
  },
  {
    "boy": "190 - 199",
    "kilo": "66 - 70",
    "vke": "17,5",
    "product": "Orta"
  },
  {
    "boy": "200+",
    "kilo": "66 - 70",
    "vke": "15,87",
    "product": "Orta"
  },
  {
    "boy": "140 - 149",
    "kilo": "71 - 75",
    "vke": "33,33",
    "product": "Orta"
  },
  {
    "boy": "150 - 159",
    "kilo": "71 - 75",
    "vke": "29,3",
    "product": "Orta"
  },
  {
    "boy": "160 - 169",
    "kilo": "71 - 75",
    "vke": "25,95",
    "product": "Orta"
  },
  {
    "boy": "170 - 179",
    "kilo": "71 - 75",
    "vke": "23,15",
    "product": "Orta"
  },
  {
    "boy": "180 - 189",
    "kilo": "71 - 75",
    "vke": "20,78",
    "product": "Orta"
  },
  {
    "boy": "190 - 199",
    "kilo": "71 - 75",
    "vke": "18,75",
    "product": "Orta"
  },
  {
    "boy": "200+",
    "kilo": "71 - 75",
    "vke": "17,01",
    "product": "Orta"
  },
  {
    "boy": "140 - 149",
    "kilo": "76 - 80",
    "vke": "35,56",
    "product": "Sert"
  },
  {
    "boy": "150 - 159",
    "kilo": "76 - 80",
    "vke": "31,25",
    "product": "Sert"
  },
  {
    "boy": "160 - 169",
    "kilo": "76 - 80",
    "vke": "27,68",
    "product": "Orta"
  },
  {
    "boy": "170 - 179",
    "kilo": "76 - 80",
    "vke": "24,69",
    "product": "Orta"
  },
  {
    "boy": "180 - 189",
    "kilo": "76 - 80",
    "vke": "22,16",
    "product": "Orta"
  },
  {
    "boy": "190 - 199",
    "kilo": "76 - 80",
    "vke": "20",
    "product": "Orta"
  },
  {
    "boy": "200+",
    "kilo": "76 - 80",
    "vke": "18,14",
    "product": "Orta"
  },
  {
    "boy": "140 - 149",
    "kilo": "81 - 85",
    "vke": "37,78",
    "product": "Sert"
  },
  {
    "boy": "150 - 159",
    "kilo": "81 - 85",
    "vke": "33,2",
    "product": "Sert"
  },
  {
    "boy": "160 - 169",
    "kilo": "81 - 85",
    "vke": "29,41",
    "product": "Sert"
  },
  {
    "boy": "170 - 179",
    "kilo": "81 - 85",
    "vke": "26,23",
    "product": "Orta"
  },
  {
    "boy": "180 - 189",
    "kilo": "81 - 85",
    "vke": "23,55",
    "product": "Orta"
  },
  {
    "boy": "190 - 199",
    "kilo": "81 - 85",
    "vke": "21,25",
    "product": "Orta"
  },
  {
    "boy": "200+",
    "kilo": "81 - 85",
    "vke": "19,27",
    "product": "Orta"
  },
  {
    "boy": "140 - 149",
    "kilo": "86 - 90",
    "vke": "40",
    "product": "Sert"
  },
  {
    "boy": "150 - 159",
    "kilo": "86 - 90",
    "vke": "35,16",
    "product": "Sert"
  },
  {
    "boy": "160 - 169",
    "kilo": "86 - 90",
    "vke": "31,14",
    "product": "Sert"
  },
  {
    "boy": "170 - 179",
    "kilo": "86 - 90",
    "vke": "27,78",
    "product": "Sert"
  },
  {
    "boy": "180 - 189",
    "kilo": "86 - 90",
    "vke": "24,93",
    "product": "Sert"
  },
  {
    "boy": "190 - 199",
    "kilo": "86 - 90",
    "vke": "22,5",
    "product": "Orta"
  },
  {
    "boy": "200+",
    "kilo": "86 - 90",
    "vke": "20,41",
    "product": "Orta"
  },
  {
    "boy": "140 - 149",
    "kilo": "91 - 95",
    "vke": "42,22",
    "product": "Sert"
  },
  {
    "boy": "150 - 159",
    "kilo": "91 - 95",
    "vke": "37,11",
    "product": "Sert"
  },
  {
    "boy": "160 - 169",
    "kilo": "91 - 95",
    "vke": "32,87",
    "product": "Sert"
  },
  {
    "boy": "170 - 179",
    "kilo": "91 - 95",
    "vke": "29,32",
    "product": "Sert"
  },
  {
    "boy": "180 - 189",
    "kilo": "91 - 95",
    "vke": "26,32",
    "product": "Sert"
  },
  {
    "boy": "190 - 199",
    "kilo": "91 - 95",
    "vke": "23,75",
    "product": "Sert"
  },
  {
    "boy": "200+",
    "kilo": "91 - 95",
    "vke": "21,54",
    "product": "Sert"
  },
  {
    "boy": "140 - 149",
    "kilo": "96 - 100",
    "vke": "44,44",
    "product": "Sert"
  },
  {
    "boy": "150 - 159",
    "kilo": "96 - 100",
    "vke": "39,06",
    "product": "Sert"
  },
  {
    "boy": "160 - 169",
    "kilo": "96 - 100",
    "vke": "34,6",
    "product": "Sert"
  },
  {
    "boy": "170 - 179",
    "kilo": "96 - 100",
    "vke": "30,86",
    "product": "Sert"
  },
  {
    "boy": "180 - 189",
    "kilo": "96 - 100",
    "vke": "27,7",
    "product": "Sert"
  },
  {
    "boy": "190 - 199",
    "kilo": "96 - 100",
    "vke": "25",
    "product": "Sert"
  },
  {
    "boy": "200+",
    "kilo": "96 - 100",
    "vke": "22,68",
    "product": "Sert"
  },
  {
    "boy": "140 - 149",
    "kilo": "101 - 105",
    "vke": "46,67",
    "product": "Sert"
  },
  {
    "boy": "150 - 159",
    "kilo": "101 - 105",
    "vke": "41,02",
    "product": "Sert"
  },
  {
    "boy": "160 - 169",
    "kilo": "101 - 105",
    "vke": "36,33",
    "product": "Sert"
  },
  {
    "boy": "170 - 179",
    "kilo": "101 - 105",
    "vke": "32,41",
    "product": "Sert"
  },
  {
    "boy": "180 - 189",
    "kilo": "101 - 105",
    "vke": "29,09",
    "product": "Sert"
  },
  {
    "boy": "190 - 199",
    "kilo": "101 - 105",
    "vke": "26,25",
    "product": "Sert"
  },
  {
    "boy": "200+",
    "kilo": "101 - 105",
    "vke": "23,81",
    "product": "Sert"
  },
  {
    "boy": "140 - 149",
    "kilo": "106 - 110",
    "vke": "48,89",
    "product": "Sert"
  },
  {
    "boy": "150 - 159",
    "kilo": "106 - 110",
    "vke": "42,97",
    "product": "Sert"
  },
  {
    "boy": "160 - 169",
    "kilo": "106 - 110",
    "vke": "38,06",
    "product": "Sert"
  },
  {
    "boy": "170 - 179",
    "kilo": "106 - 110",
    "vke": "33,95",
    "product": "Sert"
  },
  {
    "boy": "180 - 189",
    "kilo": "106 - 110",
    "vke": "30,47",
    "product": "Sert"
  },
  {
    "boy": "190 - 199",
    "kilo": "106 - 110",
    "vke": "27,5",
    "product": "Sert"
  },
  {
    "boy": "200+",
    "kilo": "106 - 110",
    "vke": "24,94",
    "product": "Sert"
  },
  {
    "boy": "140 - 149",
    "kilo": "111 - 115",
    "vke": "51,11",
    "product": "Sert"
  },
  {
    "boy": "150 - 159",
    "kilo": "111 - 115",
    "vke": "44,92",
    "product": "Sert"
  },
  {
    "boy": "160 - 169",
    "kilo": "111 - 115",
    "vke": "39,79",
    "product": "Sert"
  },
  {
    "boy": "170 - 179",
    "kilo": "111 - 115",
    "vke": "35,49",
    "product": "Sert"
  },
  {
    "boy": "180 - 189",
    "kilo": "111 - 115",
    "vke": "31,86",
    "product": "Sert"
  },
  {
    "boy": "190 - 199",
    "kilo": "111 - 115",
    "vke": "28,75",
    "product": "Sert"
  },
  {
    "boy": "200+",
    "kilo": "111 - 115",
    "vke": "26,08",
    "product": "Sert"
  }
]